var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{class:_vm.spinnerClasses}),_vm._v(" "),_c('span',{staticClass:"loading-message"},[_vm._v(_vm._s(_vm.message)+"."),_c('span',{staticClass:"blinking"},[_vm._v("..")])])])}
var staticRenderFns = []

export { render, staticRenderFns }